import { RoleCatalog } from "@/features/admin/role-catalog";

export default function AdminRolesPage() {
  return <RoleCatalog />;
}
